import script from "./SegmentedCircleBorder.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentedCircleBorder.vue?vue&type=script&setup=true&lang=js"

import "./SegmentedCircleBorder.vue?vue&type=style&index=0&id=28c5c7bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c5c7bb"]])

export default __exports__